export default __webpack_public_path__ + "static/recycle-47c692f87af840b9c9b5e1332778a8d2.png";